import type { InboxTab } from './types';

export interface InboxTabCounts {
  awaitingMe: number;
  awaitingAnyone: number;
  aiDriving: number;
  all: number;
}

const TABS: { id: InboxTab; label: string; countKey?: keyof InboxTabCounts }[] = [
  { id: 'awaiting-me', label: 'Aguardando minha ação', countKey: 'awaitingMe' },
  { id: 'awaiting-anyone', label: 'Aguardando atendente', countKey: 'awaitingAnyone' },
  // Item 366 Fase 4 — "Fila do meu time": pool dos times do operador (server-side,
  // teamQueue=mine). Sem badge agregado (count não computado para o pool de time).
  { id: 'team-queue', label: 'Fila do meu time' },
  { id: 'ai-driving', label: 'IA dirigindo', countKey: 'aiDriving' },
  { id: 'all', label: 'Todas', countKey: 'all' },
];

/**
 * Abas da Inbox completa (Brief 2B T1 §6.12).
 *
 * Tier 2 — 4 abas com contagem por aba:
 *   - Aguardando minha ação (assignedToUserId='me')
 *   - Aguardando atendente (assignedToUserId='unassigned') — destrava conv órfã (29/Mai/2026)
 *   - IA dirigindo (operationMode='H_c')
 *   - Todas (sem filter)
 */
export function InboxTabs({
  activeTab,
  counts,
  onTabChange,
}: {
  activeTab: InboxTab;
  /** Undefined enquanto o agregado carrega → abas sem badge (sem zero falso). */
  counts?: InboxTabCounts | undefined;
  onTabChange: (tab: InboxTab) => void;
}): JSX.Element {
  return (
    <div className="px-6 border-b border-border-subtle bg-canvas shrink-0">
      <nav className="page-tabs" role="tablist" aria-label="Abas da inbox">
        {TABS.map((tab) => {
          const count = tab.countKey !== undefined ? counts?.[tab.countKey] : undefined;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => onTabChange(tab.id)}
              className={['page-tab', isActive ? 'page-tab--active' : ''].filter(Boolean).join(' ')}
            >
              {tab.label}
              {count !== undefined && <span className="page-tab__count">{count}</span>}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
